import template from './template.html'
import controller from './webskedTasks.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    storyObj: '<',
    globalObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
